import { EncumbranceTypes } from 'modules/_shared/components/Modals/UpdateShares/constants/encumbranceOptions';
import { Share } from 'types';

type GetCoOwnerEncumberedSharesCountProps = {
  share: Share;
};

export const getCoOwnerEncumberedSharesCount = ({
  share,
}: GetCoOwnerEncumberedSharesCountProps): number => {
  if (!share?.encumbrances?.length) return 0;

  return share.encumbrances.reduce((acc, encumbrance) => {
    if (encumbrance?.name === EncumbranceTypes.CO_OWNERSHIP) {
      return acc + (encumbrance.to - encumbrance.from + 1);
    }
    return acc;
  }, 0);
};
